import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { mutate } from 'swr';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import {
  checkVarient,
  getCartButton,
  productActionClick,
} from '../../../Utils/productAction';
import { isDesktopUser, shouldForceClick } from '../../../Utils/ProductUtils';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { DesktopStyle, OutofStock, PdpButton } from './styled';
import { createRippleEffectRelative } from '../../../Utils/helper';

export default function DesktopButtons(props) {
  const {
    productData,
    width,
    setAddedToCart,
    showSizePopup,
    showanimation,
    fromSizePopup,
    sizePopupButtons,
    allReviews,
  } = props;
  const [cartButton, setCartButton] = useState(getCartButton(productData?.id));
  const { data } = useGetCartData();
  const [loaderState, setLoaderState] = useState('');
  const [loaderGoToCart, setLoaderGoToCart] = useState('');
  const router = useRouter();
  const pdpActionButton = useRef();
  const buyNowRef = useRef();
  useEffect(() => {
    setCartButton(getCartButton(productData?.id));
    setLoaderState('');
  }, [router.query]);

  useEffect(() => {
    // Desktop User and  key Exist in param
    if (isDesktopUser() && shouldForceClick()) {
      setTimeout(() => {
        pdpActionButton.current.click();
      }, [2000]);
    }
  }, []);

  const addGoToCart = async () => {
    if (checkVarient()) {
      if (fromSizePopup == undefined && showSizePopup) {
        showSizePopup(true);
        return true;
      } else {
        if (showanimation) showanimation(true);
        return true;
      }
    }
    if (cartButton == 1) {
      setLoaderState('loading');
      //1:"ADD TO CART",2:"GO TO CART"

      if (data) {
        await mutate('/api/getNewCartAmountOfUserWeb', null, false);
      }
      const apiResponse = await productActionClick(
        'cart',
        productData,
        cartButton,
      );
      if (apiResponse == true) {
        setLoaderState('loaded');
        setLoaderGoToCart('');
        setAddedToCart(true);
        setTimeout(() => {
          setCartButton(2); //1:"ADD TO CART",2:"GO TO CART"
        }, 800);
      } else {
        setLoaderState('');
        setCartButton(1);
      }
    } else {
      setLoaderGoToCart('loading');
      const apiResponse = await productActionClick(
        'cart',
        productData,
        cartButton,
      );
      if (apiResponse == true) {
        setLoaderState('');
        setLoaderGoToCart('loaded');
        setTimeout(() => {
          setLoaderGoToCart('');
        }, 800);
      } else {
        setLoaderGoToCart('');
      }
    }
  };
  const showLoadingScreen = (loaderState) => {
    return (
      <CssLoader className={loaderState === 'loaded' ? 'load-complete' : ''}>
        <div
          className="checkmark draw"
          style={loaderState === 'loaded' ? { display: 'block' } : {}}
        ></div>
      </CssLoader>
    );
  };

  return (
    <>
      {productData?.status === '4' &&
      (!productData.isFashionFirst || !checkVarient()) ? (
        <DesktopStyle
          allReviews={allReviews}
          stockout
          fromSizePopup={fromSizePopup}
        >
          <OutofStock desktop fromSizePopup={fromSizePopup}>
            OUT OF STOCK
          </OutofStock>
        </DesktopStyle>
      ) : (
        <DesktopStyle
          fromSizePopup={fromSizePopup}
          width={width ? 'width' : ''}
          allReviews={allReviews}
        >
          <PdpButton
            sizePopupButtons={sizePopupButtons}
            white
            onClick={() => addGoToCart()}
            ref={pdpActionButton}
            suppressHydrationWarning={true}
          >
            {cartButton == 1
              ? loaderState === 'loading' || loaderState === 'loaded'
                ? showLoadingScreen(loaderState)
                : 'ADD TO CART'
              : loaderGoToCart === 'loading' || loaderGoToCart === 'loaded'
                ? showLoadingScreen(loaderGoToCart)
                : 'GO TO CART'}
          </PdpButton>
          {fromSizePopup == undefined ? (
            <PdpButton
              desktop
              ref={buyNowRef}
              onClick={(event) => {
                createRippleEffectRelative(event, buyNowRef.current);
                productActionClick('buyNow', productData, '', showSizePopup);
              }}
            >
              BUY NOW
            </PdpButton>
          ) : null}
        </DesktopStyle>
      )}
    </>
  );
}
